/**
 * DatePickerコンポーネントに表示する日付の表示範囲といったような、DatePickerコンポーネントの制御関係の処理をまとめる
 */
export class DatePickerService {
  /**
   * DatePickerの特定の日付以前の日付をdisabledにするための関数
   * Vue-DatePickerに{((Date) => boolean)}の関数を渡す
   * trueを返したものがdisabledになる
   * https://vue3datepicker.com/props/calendar-configuration/#disabled-dates
   * @param startDate - カレンダー選択可能日付のスタート
   */
  public static getFuncValidateCalendarDatesToNextDay = (startDate: Date): ((date: Date) => boolean) => {
    return function (inputDate: Date): boolean {
      // 基準の日付（時間は無視）
      const base = new Date(startDate);
      base.setHours(0, 0, 0, 0);

      // 入力された日付の時間も無視
      const comparisonDate = new Date(inputDate);
      comparisonDate.setHours(0, 0, 0, 0);
      return comparisonDate < base;
    };
  };

  /**
   * DatePickerの特定以降の日付をdisabledにするための関数
   * Vue-DatePickerに{((Date) => boolean)}の関数を渡す
   * trueを返したものがdisabledになる
   * https://vue3datepicker.com/props/calendar-configuration/#disabled-dates
   * @param startDate - カレンダー選択可能日付のスタート
   */
  public static getFuncValidateCalendarDatesToBeforeDay = (startDate: Date): ((date: Date) => boolean) => {
    return function (inputDate: Date): boolean {
      // 基準の日付（時間は無視）
      const base = new Date(startDate);
      base.setHours(0, 0, 0, 0);

      // 入力された日付の時間も無視
      const comparisonDate = new Date(inputDate);
      comparisonDate.setHours(0, 0, 0, 0);
      return comparisonDate > base;
    };
  };

  /**
   * DatePickerの当月以外と特定の日付以降をdisabledにするための関数
   * Vue-DatePickerに{((Date) => boolean)}の関数を渡す
   * trueを返したものがdisabledになる
   * https://vue3datepicker.com/props/calendar-configuration/#disabled-dates
   * @param startDate - カレンダー選択可能日付のスタート
   */
  public static getFuncValidateCalendarDatesToCurrentMonthOnly = (startDate: Date): ((date: Date) => boolean) => {
    return function (inputDate: Date): boolean {
      // 基準の日付（時間は無視）
      const base = new Date(startDate);
      base.setHours(0, 0, 0, 0);

      // 入力された日付の時間も無視
      const comparisonDate = new Date(inputDate);
      comparisonDate.setHours(0, 0, 0, 0);

      // 基準日付の月の開始日と終了日
      const startOfMonth = new Date(base.getFullYear(), base.getMonth(), 1);
      const endOfMonth = new Date(base.getFullYear(), base.getMonth() + 1, 0);

      // 当月以外をdisableにする(trueを返す)
      const isNotSameMonth = comparisonDate < startOfMonth || comparisonDate > endOfMonth;

      // 入力された日付が基準日付の月内で、かつ基準日付以前であるかを判定
      return isNotSameMonth || comparisonDate > base;
    };
  };
}
